import React from "react";
import { Box, Typography, TypographyProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ltrEmbedSx } from "../helper/documentDirection";

/** © 2026 Al Hayat Pharmaceuticals. {localized rights line} — LTR-safe on Arabic pages. */
const LoginCopyright: React.FC<TypographyProps> = ({ sx, ...rest }) => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <Typography sx={sx} {...rest}>
      <Box component="span" sx={ltrEmbedSx}>
        © {year} Al Hayat Pharmaceuticals. {t("login.allRightsReserved")}
      </Box>
    </Typography>
  );
};

export default LoginCopyright;
